import { render } from "./GalleryApp.vue?vue&type=template&id=63f1eb6e&scoped=true"
import script from "./GalleryApp.vue?vue&type=script&lang=js"
export * from "./GalleryApp.vue?vue&type=script&lang=js"

import "./GalleryApp.vue?vue&type=style&index=0&id=63f1eb6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f1eb6e"]])

export default __exports__